import api from "../api/axios";

export const employeeService = {
    create: (data) => api.post("/employee/create", data),
    list: () => api.get("/employee/get-all"),
    getById: (id) => api.get(`/employee/get/${id}`),
    getDetail: (id) => api.get(`/employee/detail/${id}`),
    update: (data) => api.post("/employee/update", data),
    delete: (id) => api.delete(`/employee/delete/${id}`),
    receivePayment: (data) => api.post("/employee/receive-payment", data)
};
